import { useIntl } from "react-intl";

import { LoggedInJiraBlueWaveTemplateExistingUser } from "../components/logged-in-blue-wave-template-jira-existing-user";

export const LoggedInJiraStandardExistingUser = () => {
    const { formatMessage } = useIntl();

    return (
        <LoggedInJiraBlueWaveTemplateExistingUser
            productEditionText={formatMessage({
                id: `WacSignupForm.cloudStandard`,
                defaultMessage: "Cloud Standard"
            })}
        />
    );
};
